import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { PayrollSetupStyles } from './styles';
import { PermissionList, RolePermission, SaveParams } from 'utils';
import { payrollActions } from 'store';
import { PaycodeTypesList } from './paycodeTypes';
import { MileageCompensationsList } from './mileageCompensations';
import { OvertimeSettingsList } from './overtimeSettingsList';

export const PayrollSetup = ({ }) => {
    const classes = PayrollSetupStyles();
    const [activeStep, setActiveStep] = useState(
        RolePermission([PermissionList.SYSTEM_SERVICE_TYPES?.code])
            ? 0
            : RolePermission([PermissionList.SYSTEM_OVERTIME?.code])
              ? 1
              : RolePermission([PermissionList.SYSTEM_MILEAGE?.code])
                ? 2
                : null
    );
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const info = location?.state;

    useEffect(() => {
        const params = {
            ...info,
        };
        delete params.activeTab;
        if (RolePermission([PermissionList.SYSTEM_SERVICE_TYPES?.code]) && activeStep === 0) {
            dispatch(payrollActions.getPayCodeGlobal(params));
        }
        if (RolePermission([PermissionList.SYSTEM_OVERTIME?.code]) && activeStep === 1) {
            dispatch(payrollActions.getOvertimeSettingsGlobal(params));
        }
        if (RolePermission([PermissionList.SYSTEM_MILEAGE?.code]) && activeStep === 2) {
            dispatch(payrollActions.getMileages());
        }
    }, [info, activeStep]);

    const showActiveStep = (activeStep) => {
        if (activeStep === 0) {
            return <PaycodeTypesList />;
        } else if (activeStep === 1) {
            return <OvertimeSettingsList />;
        } else if (activeStep === 2) {
            return <MileageCompensationsList />;
        }
    };

    const changeActiveStep = (stepNumber) => {
        const params = {
            ...info,
        };
        delete params.type;
        SaveParams(navigate, params);
        setActiveStep(stepNumber);
    };


    return (
        <>
            <div className={classes.tabContainer} style={{marginTop: '-10px'}}>
                <>
                    {RolePermission([PermissionList.SYSTEM_SERVICE_TYPES?.code]) && (
                        <p
                            className={activeStep === 0 ? [`${classes.activeStepText} ${classes.stepText}`] : classes.stepText}
                            onClick={() => changeActiveStep(0)}
                        >
                            PayCode Types
                        </p>
                    )}
                    {RolePermission([PermissionList.SYSTEM_MILEAGE?.code]) && (
                        <p
                            className={activeStep === 2 ? [`${classes.activeStepText} ${classes.stepText}`] : classes.stepText}
                            onClick={() => changeActiveStep(2)}
                        >
                            Mileage Compensation
                        </p>
                    )}
                </>
            </div>
            <div className={classes.payrollSetupWrapper}>{showActiveStep(activeStep)}</div>
        </>
    );
};
